import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const HmsCtaBanner: React.FC = () => {
  return (
    <section className="wdev-cta hms-cta" aria-labelledby="hms-cta-title">
      <div className="container">
        <AnimatedSection>
          <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
            <div className="wdev-cta__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
                  stroke="#2563eb"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="4" stroke="#2563eb" strokeWidth="1.5" />
              </svg>
            </div>
            <div className="wdev-cta__text">
              <h2 id="hms-cta-title" className="wdev-cta__title">
                Ready to Automate Your Hospital?
              </h2>
              <p className="wdev-cta__subtitle">
                Get a demo of our hospital management system — complete automation for every department.
              </p>
            </div>
            <Link to="/contact" className="wdev-cta__btn">
              Request a Demo
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default HmsCtaBanner;
